import styled from "styled-components";

export const StyledFooter = styled.a`
  position: relative;
  width: 100%;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 0.3rem;
  padding-top: 0;
  line-height: 1.5rem;
  color: ${(props) => props.theme.footer.fontColor} !important;
  font-weight: 500;

  img {
    height: 100%;
    padding-right: 0.75rem;
  }

  p {
    font-size: 1rem;
    font-weight: 300;
  }
`;
